/* facets.js — collection/search filtering, sort, pills, load-more.
   Progressive enhancement: the facet form works server-side without JS; this
   intercepts it and re-renders via the Section Rendering API (no full reload).
   "Top rated" is a client-side sort by the Judge.me rating metafield. */
(function () {
  'use strict';

  function getSectionId() {
    var form = document.querySelector('[data-facet-form]');
    return form ? form.getAttribute('data-section-id') : null;
  }

  function sectionUrl(url) {
    var id = getSectionId();
    var u = new URL(url, window.location.origin);
    if (id) u.searchParams.set('section_id', id);
    return u.toString();
  }

  function clientSortActive() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return null;
    var opt = sel.options[sel.selectedIndex];
    return opt && opt.hasAttribute('data-client-sort') ? sel.value : null;
  }

  function maybeClientSort() {
    if (!clientSortActive()) return;
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    cards.sort(function (a, b) {
      return parseFloat(b.getAttribute('data-rating') || 0) - parseFloat(a.getAttribute('data-rating') || 0);
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  // Auto-load: click the load-more button when it nears the viewport
  var loadMoreObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var btn = entry.target.querySelector('[data-load-more]');
      if (btn && !restoring && !btn.classList.contains('is-loading')) btn.click();
    });
  }, { rootMargin: '700px 0px' }) : null;

  function observeLoadMore() {
    if (loadMoreObserver) {
      var wrap = document.querySelector('.coll-loadmore');
      if (wrap && wrap.querySelector('[data-load-more]')) loadMoreObserver.observe(wrap);
    }
  }

  function setBusy(on) {
    var results = document.querySelector('.coll-results');
    if (results) results.classList.toggle('is-loading', on);
  }

  function render(url, push) {
    setBusy(true);
    fetch(sectionUrl(url))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-collection-section]');
        var cur = document.querySelector('[data-collection-section]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        if (push !== false) window.history.pushState({ facet: true }, '', url);
        loadedPage = 1;
        maybeClientSort();
        observeLoadMore();
        // search-page.js re-fills chip counts and its other pieces from this.
        document.dispatchEvent(new CustomEvent('facets:updated'));
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { setBusy(false); });
  }

  function urlFromForm(form) {
    var params = new URLSearchParams(new FormData(form));
    // drop empties
    var clean = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '' && v != null) clean.append(k, v); });
    // "Top rated" is client-side only — don't send it to Shopify
    if (clean.get('sort_by') === 'rating') clean.delete('sort_by');
    var qs = clean.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facet-form]');
    if (!form) return;
    // pure client sort (no fetch) when only the sort changed to a client option
    if (e.target.matches('[data-sort]') && clientSortActive()) {
      maybeClientSort();
      return;
    }
    render(urlFromForm(form), true);
  });

  // Pills + clear-all (server links) → intercept to re-render
  document.addEventListener('click', function (e) {
    var toTop = e.target.closest('[data-back-to-top]');
    if (toTop) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    var link = e.target.closest('[data-facet-link]');
    if (link) { e.preventDefault(); render(link.getAttribute('href'), true); return; }

    var more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      if (restoring) return;
      var url = more.getAttribute('href');
      more.classList.add('is-loading');
      loadPage(url).catch(function () { window.location.href = url; });
    }
  });

  // Append one ?page=N of results to the grid and swap in its load-more link.
  function loadPage(url) {
    return fetch(sectionUrl(url))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var freshGrid = doc.querySelector('[data-product-grid]');
        var grid = document.querySelector('[data-product-grid]');
        if (freshGrid && grid) {
          Array.prototype.slice.call(freshGrid.children).forEach(function (c) { grid.appendChild(c); });
        }
        var freshMore = doc.querySelector('.coll-loadmore');
        var curMore = document.querySelector('.coll-loadmore');
        if (curMore) { if (freshMore) { curMore.replaceWith(freshMore); } else { curMore.remove(); } }
        loadedPage = pageOf(url);
        saveDepth();
        maybeClientSort();
        observeLoadMore();
        // search-page.js starts the broad results once the last page is in.
        document.dispatchEvent(new CustomEvent('facets:page'));
      });
  }

  /* Back-button depth. The address bar deliberately never carries ?page=N:
     Shopify renders ?page=3 as page 3 ALONE, so a product → Back trip landed
     on a third of the grid. Instead the loaded depth and scroll position live
     in sessionStorage, and a back/forward visit re-loads pages 2..N and
     scrolls to where the shopper was. */
  var restoring = false;
  var redirecting = false;
  var loadedPage = 1;

  function pageOf(url) {
    var p = parseInt(new URL(url, window.location.origin).searchParams.get('page'), 10);
    return p > 0 ? p : 1;
  }

  function depthKey() {
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    return 'coa-depth:' + u.pathname + u.search;
  }

  function saveDepth() {
    if (redirecting || !document.querySelector('[data-product-grid]')) return;
    try {
      sessionStorage.setItem(depthKey(), JSON.stringify({ page: loadedPage, y: window.scrollY }));
    } catch (err) {}
  }

  function readDepth() {
    try { return JSON.parse(sessionStorage.getItem(depthKey()) || 'null'); } catch (err) { return null; }
  }

  function isBackForward() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward';
      return performance.navigation && performance.navigation.type === 2;
    } catch (err) { return false; }
  }

  function restoreDepth() {
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;

    // A ?page=N URL (an old history entry or a shared link) would show page N
    // alone: drop the param and let the depth restore rebuild pages 1..N.
    var urlPage = pageOf(window.location.href);
    if (urlPage > 1) {
      var clean = new URL(window.location.href);
      clean.searchParams.delete('page');
      try {
        sessionStorage.setItem('coa-depth:' + clean.pathname + clean.search, JSON.stringify({ page: urlPage, y: null }));
      } catch (err) {}
      redirecting = true; // or this page's pagehide overwrites the depth just set
      window.location.replace(clean.toString());
      return;
    }

    var saved = readDepth();
    if (!saved || !(saved.page > 1)) return;
    if (!isBackForward() && saved.y !== null) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    restoring = true;
    var target = saved.page;
    var next = 2;
    (function step() {
      var more = document.querySelector('[data-load-more]');
      if (next > target || !more) {
        restoring = false;
        if (saved.y) window.scrollTo(0, saved.y);
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('page', next++);
      loadPage(url.toString()).then(step, function () { restoring = false; });
    })();
  }

  window.addEventListener('pagehide', saveDepth);

  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-collection-section]')) render(window.location.href, false);
  });

  // Mobile filter drawer (the facet rail slides in under 961px)
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-filters-toggle]');
    var close = e.target.closest('[data-filters-close]');
    var panel = document.querySelector('[data-facet-panel]');
    if (!panel) return;
    if (open) {
      var on = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', on);
      open.setAttribute('aria-expanded', String(on));
      document.body.classList.toggle('drawer-open', on);
    } else if (close) {
      panel.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      var btn = document.querySelector('[data-filters-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });

  // initial (covers a deep-linked "rating" choice)
  maybeClientSort();
  restoreDepth();
  observeLoadMore();
})();
